import React from 'react'
import { NavLink } from 'react-router-dom'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import Testimonial from '../../component/Page/Testimonial'

import Cr1 from "./svg/path/Cr1"
import Cr2 from "./svg/path/Cr2"
import Cr3 from "./svg/path/Cr3"
import Cr4 from "./svg/path/Cr4"

const Benefit = () => {
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <div className="mb__5 text-center">
                        <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024  text-capitalize color__brown mb-3">
                            <img src="./../images/Vector 2.png" alt="" />
                            <span className="mx-3">Benefit</span>
                            <img src="./../images/Vector 1.png" alt="" />
                        </div>
                        <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play">Perfect moments simply <br /> reveal themselves</h2>
                    </div>


                    <div className="row mb__5 justify-content-center">
                        <div className="col-lg-5 mb-5 mb-lg-0 text-center text-lg-left">
                            <div className="position-relative d-inline-block">
                                <img src="./../images/sc (4).png" alt="" />
                                <div className="images__path-1">
                                    <Cr1 />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024  text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">Guest list</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="medium font__size--32 text__32-1024 play mb-3">Create a guest list, mark which party they belong to, manage RSVPs, dietary restrictions and other personal guest's preferences.</h2>

                            <p className='normal font__size--18 text__18-1024'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst.</p>
                            <p className='normal font__size--18 text__18-1024'>Donec volutpat sapien in nunc pellentesque tincidunt in. Tristique eu quis duis eu dignissim. In nibh dolor est sollicitudin varius egestas elit. Neque nisl pretium pretium egestas. Commodo commodo amet varius ut quis a facilisis.</p>

                            <NavLink
                                to="/book-now" className="medium font__size--14 text__14-1024 btn btn__outlined--black color__black shadow text-capitalize rounded__50 h__white no__opacity pointer mt-3" >Book Now</NavLink>

                        </div>
                    </div>


                    <div className="row mb__5 justify-content-center">
                        <div className="order-lg-1 order-12 col-lg-6 my-auto">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024  text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">Reception</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="medium font__size--32 text__32-1024 play mb-3">Visualize your reception plan - from the layout down to the seating assignments.</h2>
                            <p className='normal font__size--18 text__18-1024'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst.</p>
                            <p className='normal font__size--18 text__18-1024'>Donec volutpat sapien in nunc pellentesque tincidunt in. Tristique eu quis duis eu dignissim. In nibh dolor est sollicitudin varius egestas elit. Neque nisl pretium pretium egestas. Commodo commodo amet varius ut quis a facilisis.</p>
                            <NavLink
                                to="/book-now" className="medium font__size--14 text__14-1024 btn btn__outlined--black color__black shadow text-capitalize rounded__50 h__white no__opacity pointer mt-3" >Book Now</NavLink>
                        </div>
                        <div className="order-1 order-lg-12 col-lg-5 mb-5 mb-lg-0 text-center text-lg-right">
                            <div className="position-relative d-inline-block">
                                <img src="./../images/sc (2).png" alt="" />
                                <div className="images__path-2">
                                    <Cr3 />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb__5 justify-content-center">
                        <div className="col-lg-5 mb-5 mb-lg-0 text-center text-lg-left">
                            <div className="position-relative d-inline-block">
                                <img src="./../images/sc (1).png" alt="" />
                                <div className="images__path-1">
                                    <Cr2 />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 my-auto">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024  text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">Venue</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="medium font__size--32 text__32-1024 play mb-3">Search for the best venues and vendors, record information about them, book your top picks. No hassle for keeping your ceremony organized.</h2>
                            <p className='normal font__size--18 text__18-1024'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst.</p>
                            <p className='normal font__size--18 text__18-1024'>Donec volutpat sapien in nunc pellentesque tincidunt in. Tristique eu quis duis eu dignissim. In nibh dolor est sollicitudin varius egestas elit. Neque nisl pretium pretium egestas. Commodo commodo amet varius ut quis a facilisis.</p>

                            <NavLink
                                to="/book-now" className="medium font__size--14 text__14-1024 btn btn__outlined--black color__black shadow text-capitalize rounded__50 h__white no__opacity pointer mt-3" >Book Now</NavLink>

                        </div>
                    </div>


                    <div className="row mb__5 justify-content-center">
                        <div className="oder-lg-1 order-12 col-lg-6 my-auto">
                            <div className="d-flex align-items-center normal font__size--24 text__24-1024  text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">Photography</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="medium font__size--32 text__32-1024 play mb-3">We also offer custom packages, so you can create a photography experience that is tailored to your preferences.</h2>
                            <p className='normal font__size--18 text__18-1024'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst.</p>
                            <p className='normal font__size--18 text__18-1024'>Donec volutpat sapien in nunc pellentesque tincidunt in. Tristique eu quis duis eu dignissim. In nibh dolor est sollicitudin varius egestas elit. Neque nisl pretium pretium egestas. Commodo commodo amet varius ut quis a facilisis.</p>

                            <NavLink
                                to="/book-now" className="medium font__size--14 text__14-1024 btn btn__outlined--black color__black shadow text-capitalize rounded__50 h__white no__opacity pointer mt-3" >Book Now</NavLink>
                        </div>
                        <div className="oder-1 order-lg-12 col-lg-5 mb-5 mb-lg-0 text-center text-lg-right">
                            <div className="position-relative d-inline-block">
                                <img src="./../images/sc (3).png" alt="" />
                                <div className="images__path-2">
                                    <Cr4 />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <Testimonial />

            <Contact />

            <Footer />
        </div >
    )
}

export default Benefit